export enum DialogType {
  content = 'content',
  confirm = 'confirm',
  alert = 'alert',
  progress = 'progress'
}
